<script>
	// The params prop contains values matched from the URL
	export let params = {};
	
	import { replace, push } from 'svelte-spa-router';
	import { createEventDispatcher, onMount } from 'svelte';
	import TBoxInterno from '../templates/TBoxInterno.svelte';
	import BarraOperacoesRegistro from '../../componentes/BarraOperacoesRegistro.svelte';
	import { 
		API, 
		TipoEvento,
		StatusHttp, 
		cabecalhoPadraoRequisicao,
		dadosUsuarioLS, 
		TextoFeedback,
		TipoPerfil, 
        removerObjeto } from '../../utils';
	import { sTituloPaginaAtual } from '../../stores';

	const dispatch = createEventDispatcher();
	let dadosUsuario;
	let opcoesOperacoes = [];
	
	let avaliacao = {};
	let objetoAvaliado = {};
	let afirmacoes = {};
	let anexos = [];
	let tituloPagina = "...";
	let subtituloPagina = "...";
	
	const AJUSTE_LIKERT = 3;

	const itensAvaliacaoLikert = [
		'Discordo totalmente', 
		'Discordo parcialmente',
		'Não discordo nem concordo',
		'Concordo parcialmente',
		'Concordo totalmente'
	];

	onMount(async () => {
		$sTituloPaginaAtual = `Visualização de Avaliação (ID: ${params.id.padStart(4, '0')})`;
		
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Carregando avaliação ...',
		});

		const resposta = await fetch(API(`avaliacoes/${params.id}`), {
			method: 'GET',
			headers: cabecalhoPadraoRequisicao()
		}).catch(erros => {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});

			replace("#/painel");
		});
		
		const { dados } = await resposta.json();
		// console.log(dados);
		if (resposta.status == StatusHttp.OK) {
			objetoAvaliado = dados.objetoAvaliado;
			afirmacoes = dados.afirmacoes;
			anexos = objetoAvaliado?.anexos;
			tituloPagina = objetoAvaliado?.titulo ?? objetoAvaliado?.projeto?.titulo;
			subtituloPagina = `Tipo de objeto avaliado: ${dados.objetoAvaliadoEProjeto == true ? 'PROJETO' : 'APRESENTAÇÃO SEM. GRADUAÇÃO'}`;
			
			avaliacao = {
				pontuacao: dados.pontuacao,
				anotacoes: dados.anotacoes,
				finalizada: dados.finalizada,
				data_ultima_atualizacao: dados.data_ultima_atualizacao,
				renovacao: dados.renovacao,
				avaliador: dados.avaliador.nome
			};

			dadosUsuario = dadosUsuarioLS();

			opcoesOperacoes = [
				{
					titulo: 'Início',
					callback: () => push('#/')
				},
				{
					titulo: 'Painel',
					callback: () => push('#/painel')
				}
			];

			switch (dadosUsuario.perfil) {
				case TipoPerfil.CETREINA:
					if (dados.objetoAvaliadoEProjeto == true) {
						opcoesOperacoes.push({
							titulo: 'Ver Projeto',
							callback: () => push(`#/projeto/visualizar/${objetoAvaliado.codigo}`)
						});
					} else {
						opcoesOperacoes.push({
							titulo: 'Ver Apresentação',
							callback: () => push(`#/apresentacao/visualizar/${objetoAvaliado.id}/${objetoAvaliado.projeto.codigo}`)
						});
					}

					opcoesOperacoes.push({
						titulo: 'Remover',
						cor: 'is-danger',
						callback: () => removerAvaliacao(params.id)
					});
				break
			}
		} else {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			replace('#/avaliacao-inexistente');

			return;
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});

	const removerAvaliacao = async (idAvaliacao) => removerObjeto(idAvaliacao, dispatch, push, '#/painel', 'avaliacoes', 'Deseja realmente remover esta avaliação? \n\nA avaliação só poderá ser recupera por solicitação via e-mail, com justificativa.');
</script>

<TBoxInterno
	titulo={tituloPagina}
	subtitulo={subtituloPagina}
	largura="12" 
	deslocamento="0">

	<div class="columns is-mobile">
		<div class="column">
			<p>Pontuação total que o projeto/apresentação recebeu com esta avaliação: { avaliacao.pontuacao }</p>
		</div>
	</div>

	<hr>

	<p class="is-size-4 mb-4">Avaliação:</p>
	
	<div class="content">
		<table class="table is-fullwidth is-hoverable">
			<thead>
				<tr>
					<th>#</th>
					<th>Item avaliado</th>
					<th>Intenção avaliativa</th>
					<th title="Avaliação do item atribuída pelo(a) avaliador(a)">Avaliação do item</th>
					<th>Pontos</th>
				</tr>
			</thead>
			<tbody>
				{#each Object.values(afirmacoes) as afirmacao, i}
				<tr>
					<td>{ ++i }</td> 
					<td>{ afirmacao.titulo }</td>
					<td>{ afirmacao.intencao }</td>
					<td>{ itensAvaliacaoLikert[afirmacao.pontuacao - 1] }</td>
					<td class="has-text-right">{ afirmacao.intencao == 'POSITIVA' ? (afirmacao.pontuacao - AJUSTE_LIKERT) : (afirmacao.pontuacao - AJUSTE_LIKERT) * (-1) }</td>
				</tr>
				{:else}
				<td colspan="5" class="has-text-danger has-text-centered">Avaliação ainda não finalizada.</td>
				{/each}
			</tbody>
		</table>

		<p class="is-size-4 mb-4">Anotações do(a) avaliador(a)</p>
		
		<div class="box">
			{ avaliacao.anotacoes }
		</div>

		{#if anexos?.length > 0}
		<p class="is-size-4 mb-4">Anexos</p>

		<table class="table is-fullwidth is-hoverable permitir-selecao">
			<thead>
				<tr>
					<th>#</th>
					<th>Tipo</th>
					<th>Valor</th>
				</tr>
			</thead>
			<tbody>
				{#each anexos as anexo, i}
				<tr>
					<th>{ ++i }</th> 
					<td>{ anexo.tipo }</td>
					<td>{ anexo.valor.trim() }</td>
				</tr>
				{/each}
			</tbody>
		</table>
		{/if}
	</div>

	<p class="has-text-centered">
		<span class="has-text-info">Avaliador(a): { avaliacao.avaliador }</span>
		<br>
		<span class="tag" title="Data da avaliação">{avaliacao.data_ultima_atualizacao}</span>
	</p>
	
	<br>
	<br>

	<BarraOperacoesRegistro opcoes={ opcoesOperacoes } />
</TBoxInterno>